/**
 * #294 committed-drift heal — CSRF-authenticated resync mutation.
 * Mirrors payments.ts: read the `pacebi_csrf` cookie, echo via `X-CSRF-Token`.
 * A fresh idempotency_key per call so a double-click can't double-post.
 */

export interface ResyncResult {
  ok: boolean;
  data?: { sid: number; tnum: number; no_commit: boolean; duplicate?: boolean };
}

function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

export async function resyncCommit(sid: number, tnum: number): Promise<ResyncResult> {
  const csrf = readCookie('pacebi_csrf');
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (csrf) headers['X-CSRF-Token'] = csrf;
  const res = await fetch('/api/commit-drift/resync', {
    method: 'POST',
    credentials: 'same-origin',
    headers,
    body: JSON.stringify({ sid, tnum, idempotency_key: crypto.randomUUID() }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return (await res.json()) as ResyncResult;
}
